"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatDate = exports.mapSchema = void 0;
var moment = require("moment");
var sok_types_1 = require("@caddigital/sok-types");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var fieldNames = [
    { name: 'name', identifier: 'name-meta' },
    { name: 'status', identifier: 'description-meta' },
    { name: 'reportRetrieved', identifier: 'added-meta' },
    { name: 'retrievedBy', identifier: 'added-by-meta' }
];
var defaults = {
    name: '',
    type: 'text',
    bitField: sok_types_1.CustomMeta.FILES_LIST,
    editable: false,
    hideOnFileList: false,
    identifier: '',
    mandatory: false,
    order: 0,
    required: false
};
var mapSchema = function (fileMeta, localizationPath) {
    return fieldNames.map(function (field, index) {
        var _a, _b, _c;
        var org = fileMeta.find(function (meta) { return meta.identifier === field.identifier; });
        var uniq = index + 1000;
        return __assign(__assign({}, defaults), { id: (_a = org === null || org === void 0 ? void 0 : org.id) !== null && _a !== void 0 ? _a : uniq, name: (0, translation_1.getLocalization)("".concat(localizationPath, "/").concat(field.name)), identifier: field.identifier, type: (_b = org === null || org === void 0 ? void 0 : org.type) !== null && _b !== void 0 ? _b : defaults.type, order: (_c = org === null || org === void 0 ? void 0 : org.order) !== null && _c !== void 0 ? _c : uniq });
    });
};
exports.mapSchema = mapSchema;
var formatDate = function (dateInput) {
    return !dateInput ? '-' : moment(dateInput).format('L LT');
};
exports.formatDate = formatDate;
